// [Insider+] Routes inside the embedded insider-plus app. insider-plus is a
// separate repo that deploys on its own, so keep these in sync with its
// src/App.tsx — if a route is renamed there, links built from these paths
// break with no build or test failure here.
export const INSIDER_PLUS_APP_PATHS = {
  join: '/join',
  welcome: '/welcome',
  indicators: '/indicators',
  webinars: '/webinars',
  newsletters: '/newsletters?tab=briefing',
  // Opens Discourse in a new tab. Opened from the parent header the browser
  // usually blocks that tab, and insider-plus then shows an "Open forum"
  // button instead.
  forum: '/forum',
};

// insider-plus has no Metals Playbook index page (/metals-playbook redirects
// to /welcome), so link straight to the course. The course id comes from the
// benefits response (CurrentCourseId) rather than being hardcoded here.
export const getMetalsPlaybookCoursePath = (courseId) =>
  `/metals-playbook/${encodeURIComponent(courseId)}`;
